import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FiltroPesquisaDemandaDTO } from 'src/app/entity/FiltroPesquisaDemandaDTO';
import { ManifestoService } from 'src/app/service/manifesto/manifesto.service';
import { ResultadoFiltroDemandaVO } from 'src/app/entity/ResultadoFiltroDemandaVO';
import { MANIFESTO_ENUM } from 'src/app/tools/Manifestos';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { MSG_NENHUM_REGISTRO } from 'src/app/tools/Mensagens';
import { Router } from '@angular/router';
import { CadastroUsuario } from 'src/app/entity/CadastroUsuario';
import { PesquisarUsuarioService } from 'src/app/service/usuario/pesquisar-usuario.service';
import { PAGINA_HOME } from 'src/app/tools/URL';
import { AuthService } from 'src/app/service/autenticacao/auth.service';


const MAX_PAGE = 10;
const MAX_PAGINACAO = 5;

@Component({
  selector: 'pesquisa-manifesto-usuario',
  templateUrl: './pesquisa-manifesto-usuario.component.html',
  styleUrls: ['./pesquisa-manifesto-usuario.component.css']
})
export class PesquisaManifestoUsuarioComponent implements OnInit, AfterViewInit {

  filtro: FiltroPesquisaDemandaDTO;
  listaManifestos: any[];
  usuarios: Array<CadastroUsuario>;
  resultado: ResultadoFiltroDemandaVO;
  home =  PAGINA_HOME;
  idManifesto: number;
  dataInicial: string;
  dataFinal: string;
  shortcuts: ShortcutInput[];

  constructor(private manifestoService: ManifestoService,
    private router: Router,
    private authService: AuthService,
    private pesquisarUsuarioService: PesquisarUsuarioService) {

    this.manifestoService.carregarDados().subscribe(manifestos => {

        this.listaManifestos = manifestos.filter(manifesto => manifesto.numeroOrdem !== '1').sort((a, b) => {

          const aEnumKey = Object.keys(MANIFESTO_ENUM).find(key => MANIFESTO_ENUM[key].id === a.id);
          const bEnumKey = Object.keys(MANIFESTO_ENUM).find(key => MANIFESTO_ENUM[key].id === b.id);

          return MANIFESTO_ENUM[aEnumKey].ordem - MANIFESTO_ENUM[bEnumKey].ordem;

        });
        this.listaManifestos.unshift(MANIFESTO_ENUM.TODOS);

      }
    );
    this.resultado = new ResultadoFiltroDemandaVO();
    this.filtro = new FiltroPesquisaDemandaDTO();
    this.shortcuts = [];
    this.usuarios = [];

  }

  ngOnInit() { }

  ngAfterViewInit(): void {

    this.shortcuts.push(
      {
        key: 'alt + l',
        preventDefault: true,
        command: () => {

          if (this.filtroValido(this.filtro)) {

            this.filtroBotao(this.filtro);

          }

        }
      },
      {
        key: 'alt + z',
        preventDefault: true,
        command: () => this.limparFiltro()
      }
      // ,
      // {
      //   key: 'alt + c',
      //   preventDefault: true,
      //   command: () => this.router.navigate([PAGINA_HOME_USUARIO_INTERNO])
      // }
    );

  }

  // editarManifesto(manifesto) {

  //   let tipoManifesto = Object.keys(MANIFESTO_ENUM).find(key => MANIFESTO_ENUM[key].id === this.idManifesto);

  //   if (this.idManifesto === 0) {

  //     tipoManifesto = manifesto.tipoManifesto;

  //   }

  //   this.router.navigate([PAGINA_MANIFESTO_OPERADOR, tipoManifesto.toLowerCase(), manifesto.id]);

  // }

  filtroValido(filtro: FiltroPesquisaDemandaDTO): boolean {

    if (!this.idManifesto && this.idManifesto !== 0) {

      return false;

    }

    if (!filtro.email && !filtro.manifestante && !this.dataInicial && !this.dataFinal) {

      return false;

    }

    if (this.dataInicial && !this.dataFinal) {

      return false;

    }

    if (this.dataFinal && !this.dataInicial) {

      return false;

    }

    return true;

  }

  formatarFiltro(filtro: FiltroPesquisaDemandaDTO) {

    filtro.dataInicial = undefined;
    filtro.dataFinal = undefined;

    filtro.manifesto = Object.keys(MANIFESTO_ENUM).find(key => MANIFESTO_ENUM[key].id === this.idManifesto);

    if (filtro.manifestante === '') {

      filtro.manifestante = undefined;

    }

    if (this.dataInicial) {

      filtro.dataInicial = this.dataInicial.slice(0, 10);

    }

    if (this.dataFinal) {

      filtro.dataFinal = this.dataFinal.slice(0, 10);

    }

  }

  // buscarUsuario() {

  //   this.pesquisarUsuarioService.findByName(this.filtro.manifestante)
  //     .subscribe(usuarios => this.usuarios = usuarios,
  //     erro => console.log(erro));

  // }

  // manifestanteDigitado() {

  //   this.usuarios = [];
  //   this.filtro.email = null;

  // }

  // usuarioEscolhido(filtro: FiltroPesquisaDemandaDTO) {

  //   this.filtro.manifestante = undefined;

  // }

  filtroBotao(filtro: FiltroPesquisaDemandaDTO) {

    this.formatarFiltro(filtro);
    this.filtrar(filtro);

  }

  filtrar(filtro: FiltroPesquisaDemandaDTO) {

    this.filtro.manifestante = this.authService.usuarioLogado.nome;
    this.filtro.email = this.authService.usuarioLogado.email;

    this.manifestoService.filtrarDemandasUsuario(filtro).subscribe((resultado: ResultadoFiltroDemandaVO) => {

      if (this.idManifesto === MANIFESTO_ENUM.TODOS.id ||
        this.idManifesto === MANIFESTO_ENUM.DENUNCIA.id ||
        this.idManifesto === MANIFESTO_ENUM.LGPD.id) {

        resultado.manifestos.forEach(manifesto => {

          if (manifesto.anonimo == true) {

            manifesto.nome = 'SIGILOSO';
            manifesto.email = 'SIGILOSO';

          }

        });

      }

      this.resultado = resultado;

      if (this.resultado.manifestos.length === 0) {

        alert(MSG_NENHUM_REGISTRO);

      }

    }, err => console.log(err));

  }

  limparFiltro() {

    this.idManifesto = undefined;
    this.filtro = new FiltroPesquisaDemandaDTO();
    this.resultado = new ResultadoFiltroDemandaVO();
    this.dataInicial = undefined;
    this.dataFinal = undefined;
    this.usuarios = [];

    document.getElementById('manifestante').focus();

  }

  setPreviousPage(filtro: FiltroPesquisaDemandaDTO) {

    if (filtro.page > 0) {

      filtro.page--;
      this.filtrar(filtro);

    }

  }

  setNextPage(filtro: FiltroPesquisaDemandaDTO) {

    if (filtro.page < this.resultado.totalPaginas - 1) {

      filtro.page++;
      this.filtrar(filtro);

    }

  }

  setPage(filtro: FiltroPesquisaDemandaDTO, pagina: number) {

    if (filtro.page !== pagina) {

      filtro.page = pagina;
      this.filtrar(filtro);

    }

  }

  setFirstPage(filtro: FiltroPesquisaDemandaDTO) {

    this.setPage(filtro, 0);

  }

  setLastPage(filtro: FiltroPesquisaDemandaDTO) {

    this.setPage(filtro, this.resultado.totalPaginas - 1);

  }

}
